import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=9e86b050&"
import script from "./ClientCard.vue?vue&type=script&lang=ts&"
export * from "./ClientCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports